export interface VisibilityEntry {
  hidden: boolean;
  timestamp: number;
}

export function startVisibilityCapture(
  callback: (entry: VisibilityEntry) => void
): () => void {
  const handler = () => {
    try {
      callback({ hidden: document.hidden, timestamp: Date.now() });
    } catch {
      // noop
    }
  };

  document.addEventListener('visibilitychange', handler);

  return () => {
    document.removeEventListener('visibilitychange', handler);
  };
}
